import type { ReactNode } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogDescription,
  DialogFooter,
  DialogHeader,
} from "../ui/dialog";
import { cn } from "@/utils/theme";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  header?: ReactNode;
  footer?: ReactNode;
  children?: ReactNode;
  modalContentClassName?: string;
  modalChildrenClassName?: string;
  modalHeaderClassName?: string;
  modalFooterClassName?: string;
  title?: string;
  description?: string;
  allowScroll?: boolean;
  modal?: boolean;
}

const ScrollModal = ({
  isOpen,
  onClose,
  header,
  footer,
  children,
  modalContentClassName,
  modalChildrenClassName,
  modalHeaderClassName,
  modalFooterClassName,
  title = "Modal",
  description,
  allowScroll = true,
  modal = true,
}: Props) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose} modal={modal}>
      <DialogTitle className="sr-only">{title}</DialogTitle>
      {description && (
        <DialogDescription className="sr-only">{description}</DialogDescription>
      )}
      <DialogContent
        showCloseButton={false}
        className={cn(
          `flex flex-col max-h-[90vh] w-full max-w-130 p-0 shadow-neutral-2xl `,
          modalContentClassName,
        )}
      >
        {header && (
          <DialogHeader
            className={cn(
              "bg-neutral-object border-b border-neutral-silent rounded-t-xl",
              modalHeaderClassName,
            )}
          >
            {header}
          </DialogHeader>
        )}
        <div
          className={cn(
            "flex-1 min-h-0 flex flex-col bg-neutral-foreground",
            allowScroll && "overflow-y-auto",
            modalChildrenClassName,
          )}
        >
          {children}
        </div>
        {footer && (
          <DialogFooter
            className={cn(
              "bg-neutral-object border-t border-neutral-silent rounded-b-xl",
              modalFooterClassName,
            )}
          >
            {footer}
          </DialogFooter>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ScrollModal;
